module.exports = __webpack_public_path__ + "static/media/CostChart_fr.94c781be.png";